import Marquee from "react-fast-marquee";

const items = [
  "Small Local Moves",
  "Apartment Relocations",
  "Furniture Moving",
  "Loading & Unloading",
  "Storage Moves",
  "Office Moves",
  "Short-Notice Help",
];

export const Ribbon = () => (
  <div
    data-testid="marquee-ribbon"
    className="relative z-10 border-y border-white/10 bg-[#262626] py-5"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl text-neutral-200 mx-6">
            {it}
          </span>
          <span className="h-2 w-2 rounded-full bg-[#FF4500] mx-6" />
        </span>
      ))}
    </Marquee>
  </div>
);
